
import A1 from '../images/A1.jpeg'; import A2 from '../images/A2.jpeg'; import A3 from '../images/A3.jpeg'; import A4 from '../images/A4.jpeg'; import A5 from '../images/A5.jpeg'; import A6 from '../images/A6.jpeg'; import A7 from '../images/A7.jpeg'; import A8 from '../images/A8.jpeg'; import A9 from '../images/A9.jpeg'; import A10 from '../images/A10.jpeg';
import B1 from '../images/B1.png';
import B11 from '../images/B11.png';
import B2 from '../images/B2.jpeg';
import B3 from '../images/B3.jpeg';
import B4 from '../images/B4.jpeg';
import B5 from '../images/B5.jpeg';
import B6 from '../images/B6.jpeg';
import B7 from '../images/B7.jpeg';
import B8 from '../images/B8.jpeg';





import E1 from '../images/E1.jpeg';
import E2 from '../images/E2.jpeg';
import E3 from '../images/E3.jpeg';
import E4 from '../images/E4.jpeg';
import E5 from '../images/E5.jpeg';
import E6 from '../images/E6.jpeg';
import E7 from '../images/E7.jpeg';
import E8 from '../images/E8.jpeg';
import E9 from '../images/E9.jpeg';
import E10 from '../images/E10.jpeg';
import E11 from '../images/E11.jpeg';
import E12 from '../images/E12.jpeg';
import E13 from '../images/E13.jpeg';
import E14 from '../images/E14.jpeg';
import E15 from '../images/E15.jpeg';
import E16 from '../images/E16.jpeg';

import F1 from '../images/F1.jpeg'; import F2 from '../images/F2.jpeg'; import F3 from '../images/F3.jpeg'; import F4 from '../images/F4.jpeg'; import F5 from '../images/F5.jpeg'; import F6 from '../images/F6.jpeg'; import F7 from '../images/F7.jpeg'; import F8 from '../images/F8.jpeg'; import F9 from '../images/F9.jpeg'; import F10 from '../images/F10.jpeg';
import G1 from '../images/G1.jpg'; import G2 from '../images/G2.jpg'; import G3 from '../images/G3.jpg'; import G4 from '../images/G4.jpg'; import G5 from '../images/G5.jpg'; import G6 from '../images/G6.jpg'; import G7 from '../images/G7.jpg'; import G8 from '../images/G8.jpg'; import G9 from '../images/G9.jpg'; import G10 from '../images/G10.jpg'; import G11 from '../images/G11.jpg'; import G12 from '../images/G12.jpg'; import G13 from '../images/G13.jpg';
import H1 from '../images/H1.jpeg'; import H2 from '../images/H2.jpeg'; import H3 from '../images/H3.jpeg'; import H4 from '../images/H4.jpeg'; import H5 from '../images/H5.jpeg'; import H6 from '../images/H6.jpeg'; import H7 from '../images/H7.jpeg'; import H8 from '../images/H8.jpeg'; import H9 from '../images/H9.jpeg'; import H10 from '../images/H10.jpeg'; import H11 from '../images/H11.jpeg'; import H12 from '../images/H12.jpeg'; import H13 from '../images/H13.jpeg'; import H14 from '../images/H14.jpeg'; import H15 from '../images/H15.jpeg'; import H16 from '../images/H16.jpeg'; import H17 from '../images/H17.jpeg';
import I1 from '../images/I1.jpeg'; import I2 from '../images/I2.jpeg'; import I3 from '../images/I3.jpeg'; import I4 from '../images/I4.jpeg'; import I5 from '../images/I5.jpeg'; import I6 from '../images/I6.jpeg'; import I7 from '../images/I7.jpeg'; import I8 from '../images/I8.jpeg'; import I9 from '../images/I9.jpeg'; import I10 from '../images/I10.jpeg'; import I11 from '../images/I11.jpeg'; import I12 from '../images/I12.jpeg'; import I13 from '../images/I13.jpeg'; import I14 from '../images/I14.jpeg'; import I15 from '../images/I15.jpeg'; import I16 from '../images/I16.jpeg'; import I17 from '../images/I17.jpeg'; import I18 from '../images/I18.jpeg'; import I19 from '../images/I19.jpeg';
import J1 from '../images/J1.jpeg'; import J2 from '../images/J2.jpeg'; import J3 from '../images/J3.jpeg'; import J4 from '../images/J4.jpeg'; import J5 from '../images/J5.jpeg'; import J6 from '../images/J6.jpeg'; import J7 from '../images/J7.jpeg'; import J8 from '../images/J8.jpeg'; import J9 from '../images/J9.jpeg';
import K1 from '../images/K1.jpeg'; import K2 from '../images/K2.jpeg'; import K3 from '../images/K3.jpeg'; import K4 from '../images/K4.jpeg'; import K5 from '../images/K5.jpeg'; import K6 from '../images/K6.jpeg'; import K7 from '../images/K7.jpeg'; import K8 from '../images/K8.jpeg'; import K9 from '../images/K9.jpeg'; import K10 from '../images/K10.jpeg'; import K11 from '../images/K11.jpeg'; import K12 from '../images/K12.jpeg';


const accommodations = [

        {
    name: "Staywise Student Accomodation",
    location: "6 Jan Vilojoen Street",
    price: "NFSAS Accredited",
    distance: "2km to VUT , Bus Transport Provided to VUT",
    paymentType: "No deposit required! En‑suite bedrooms, unlimited WiFi, laundry facilities, 24‑hour security, shops & gym nearby, plus sports, TV lounge, and entertainment areas.",
    whatsappNumber: "27769363454",
images: [ I1, I2, I3, I10, I11, I12, I13, I14, I15, I4, I5, I6, I7, I8, I9 ,I16, I17, I18, I19 ]
  },
  {
    name: "Golden Nest Student Accommodation",
    location: "25 Bellona Avenue Bedworthpark",
    price: "NSFAS Accredited both VUT and NWU",
    distance: "2Km to VUT and 5Km to NWU",
    paymentType: "NSFAS accredited single rooms with unlimited WiFi, solar backup, laundry facilities, top-level security, swimming pool",

    whatsappNumber: "27749422003",
    images: [ K1, K2, K3, K4, K5, K6, K7, K8, K9, K10, K11, K12 ]
  },
      {
    name: "Ekhaya  Student Residence",
    location: "Riverbend Gardens",
    price: " NFSAS Accredited / R4,700/month ",
    distance: "1km to North West Vanderblijpark",
    paymentType: "Single Rooms with  Unlimited Wifi,Backup Generator and Laundry Room with Washing Machines",
    whatsappNumber: "27762691158",
    images: [
     E1, E2, E3, E4, E5, E6,
     E7, E8, E9, E10, E11, E12, E13,E14,E15,E16
]

  },
  ,
  {
    name: "36 President Hoffman ",
    location: " 36 President Hoffman St Vanderbijlpark ",
    price: "Nfsas Accredited",
    distance: "5 min from VUT with transport Provided to VUT",
    paymentType: "Nsfas Accreditated. Both Single and sharing rooms with unlimited WiFi Back up , Generator, solar system and gas stove and geyser",
    whatsappNumber: "27794003053",
   images: [ G1, G2, G3, G4, G5, G6, G7, G8, G9, G10, G11, G12, G13 ]
  },
  {
  name: "Home Away Accommodation (HAA)",
  location: "16 Sparrman Street, SE7, VUT Main Gate",
  price: "NSFAS Accredited both VUT and NWU",
  distance: "200m from VUT ,4KM  from NWU with transport Provided to NWU",
  paymentType: "28 Single Rooms and En-suite rooms, Solar Power (Backup), Unlimited Wi-Fi (Fiber), Smart DSTV, Entertainment Area with Braai Area, Washing Machines, Refrigerators and Microwaves, Gas Stoves, 24-hour Surveillance Security Cameras, Armed Security Response",
  whatsappNumber: "221778673551", 
images: [ H1, H2, H3, H4, H5, H6, H7, H8,H9, H10, H11, H12, H13, H14, H15, H16, H17  ]
},
   {
    name: "Lindiza Student Residence",
    location: "20 Badenhorst Street Vanderbijlpark",
    price: "NSFAS Accredited VUT and Sedibeng",
    distance: "5 min from VUT with transport Provided to VUT and Sedibeng",
    paymentType: "We take 6‑month students! NSFAS accredited residence with ensuite rooms, laundry (washing machine & tumble dryer), fridge & chest freezer, microwave, covered lapa, 24‑hour armed response, camera surveillance, unlimited WiFi, plus a TV lounge with couch.",
    whatsappNumber: "27832560553",
    images: [
         A1,A2,A3,A4,A5,A6,A7,A8,A9,A10
         
      
    ]
  },
   {
    name: "Dithsegofatso student accommodation ",
    location: "5 William porter Se7 Vanderbijlpark ",
    price: "NSFAS Accredited",
    distance: "0.5km to VUT",
    paymentType : "Single rooms with one shared option (own fridge). 6 toilets, 8 showers, solar backup, laundry with 3 machines, and Jojo tank for water backup — designed for comfort and convenience",
    whatsappNumber: "27766619046",
    
    images: [ J1, J2, J3, J4, J5, J6, J7, J8, J9 ]
  },


      {
    name: "Formaxvilla Student Accomodation",
    location: "Riverbend Gardens",
    price: " R4,700/month",
    distance: "1km to North West Vanderblijpark",
    paymentType: "Nfsas Accredited,Single Rooms with  Unlimited Wifi,Backup Generator and Laundry Room with Washing Machines",
    whatsappNumber: "27762691158",
 images: [ F1, F2, F3, F4, F5, F6, F7, F8, F9, F10 ]

  },


  {
    name: "Nkosi Student Accomodation",
    location: "Bedworth Cassandra",
    price: "R3,200/month",
    distance: "1km to VUT",
    paymentType: "NSFAS Accredited",
    whatsappNumber: "27729792961",
    images: [
       B1 , B11,B2 , B3,B4,B5,B6,B7,B8
    ]
  },
  


    ]

export default accommodations;
